// client\src\api\authClient.js

const API =
  typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL
    ? String(import.meta.env.VITE_API_URL).replace(/\/$/, "")
    : typeof window !== "undefined" && window.location
      ? `${window.location.protocol}//${window.location.host}`
      : "";

export const AUTH_API_BASE = API;

/* ===================== helpers ===================== */

async function readJsonSafe(res) {
  try {
    return await res.json();
  } catch {
    return {};
  }
}

function pickErrorMessage(data, res) {
  const msg =
    (data && (data.message || data.error)) ||
    (res ? `HTTP ${res.status}` : "Ошибка запроса");
  return String(msg);
}

async function postJSON(url, body) {
  const res = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });

  const data = await readJsonSafe(res);

  if (!res.ok) {
    const msg =
      data?.error || data?.message || `Ошибка запроса (${res.status})`;
    throw new Error(msg);
  }

  return data;
}

async function getJSON(url) {
  const res = await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
    cache: "no-store",
  });

  const data = await readJsonSafe(res);

  if (!res.ok) {
    const msg =
      data?.error || data?.message || `Ошибка запроса (${res.status})`;
    throw new Error(msg);
  }

  return data;
}

async function delJSON(url, body) {
  const res = await fetch(url, {
    method: "DELETE",
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : {},
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await readJsonSafe(res);

  if (!res.ok) {
    const msg =
      data?.error || data?.message || `Ошибка запроса (${res.status})`;
    throw new Error(msg);
  }

  return data;
}

/* ===================== STUDENTS ===================== */

export const registerStudent = (payload) =>
  postJSON(`${API}/api/auth/register-student`, payload);

export const login = (payload) => postJSON(`${API}/api/auth/login`, payload);

export const forgotPassword = (payloadOrEmail) =>
  postJSON(
    `${API}/api/auth/forgot-password`,
    typeof payloadOrEmail === "string"
      ? { email: payloadOrEmail }
      : payloadOrEmail || {},
  );

export const resetPassword = (payload) =>
  postJSON(`${API}/api/auth/reset-password`, payload);

/* ===================== TUTORS ===================== */

export const registertutor = (payload) =>
  postJSON(`${API}/api/auth/register-tutor`, payload);

export const logintutor = (payload) =>
  postJSON(`${API}/api/auth/login-tutor`, payload);

export const forgotPasswordtutor = (payloadOrEmail) =>
  postJSON(
    `${API}/api/auth/forgot-password-tutor`,
    typeof payloadOrEmail === "string"
      ? { email: payloadOrEmail }
      : payloadOrEmail || {},
  );

export const resetPasswordtutor = (payload) =>
  postJSON(`${API}/api/auth/reset-password-tutor`, payload);

/* ===================== COMMON ===================== */

export const verifyEmail = (token, role) =>
  getJSON(
    `${API}/api/auth/verify?token=${encodeURIComponent(token)}&role=${encodeURIComponent(role || "student")}`,
  );

export const me = async (role = "student") => {
  if (role === "tutor") {
    const r = await getJSON(`${API}/api/tutor/me`);
    return {
      ok: !!r?.ok,
      user: {
        id: String(r?.tutor?._id || ""),
        email: String(r?.tutor?.email || ""),
        role: "tutor",
      },
    };
  }

  return getJSON(`${API}/api/student/me`);
};
const STUDENT_DASHBOARD_CACHE_KEY = "studentDashboard:lastSummary";
const STUDENT_DASHBOARD_LAST_USER_KEY = "studentDashboard:lastUserId";

export const logout = async (role) => {
  const url =
    role === "student" || role === "tutor"
      ? `${API}/api/auth/logout?role=${encodeURIComponent(role)}`
      : `${API}/api/auth/logout`;

  try {
    await fetch(url, { method: "POST", credentials: "include" });
  } catch {}

  // ✅ важно: чистим кеши/хвосты фронта, чтобы не показывались чужие данные
  try {
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem(STUDENT_DASHBOARD_CACHE_KEY);
      localStorage.removeItem(STUDENT_DASHBOARD_LAST_USER_KEY);
      localStorage.removeItem("postAuth:openCourse");
    }
  } catch {}

  try {
    if (typeof sessionStorage !== "undefined") {
      // если у тебя есть какие-то sessionStorage флаги — можно чистить тут
      // sessionStorage.clear(); // не обязательно, но можно
    }
  } catch {}

  return { ok: true };
};


export const sendContact = (form) => postJSON(`${API}/api/auth/contact`, form);

/* ===================== DELETE ===================== */

export const getDeletePreview = () => getJSON(`${API}/api/auth/delete-preview`);

export const getDeletePreviewTutor = () =>
  getJSON(`${API}/api/auth/delete-preview-tutor`);

export const deleteAccount = (body = {}) =>
  delJSON(`${API}/api/auth/delete`, body);

export const deleteAccountTutor = (body = {}) =>
  delJSON(`${API}/api/auth/delete-tutor`, body);
